/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { CSSProperties, useState } from 'react';
import {
  FormGroup,
  FormControl,
  FormControlProps,
  ControlLabel
} from '@devstart/react-bootstrap';
import HidePassword from '../../../assets/icons/hide-password';
import ShowPassword from '../../../assets/icons/show-password';

import './input-password.css';

type InputPasswordProps = typeof FormControlProps & {
  hasError?: boolean;
  messageError?: string;
  label?: string;
  style: CSSProperties;
};

function InputPassword({
  hasError,
  messageError,
  label,
  style = {},
  ...rest
}: InputPasswordProps): JSX.Element {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const borderStyle: CSSProperties = { borderRadius: '8px', ...style };

  const [showPassword, setShowPassword] = useState(false);

  const hasErrorStyle = hasError
    ? { color: '#DC3545', fontSize: '12px', fontWeight: '400' }
    : {};

  return (
    <FormGroup className='input-container'>
      {label && <ControlLabel>{label}</ControlLabel>}
      <div id='password-container'>
        <FormControl
          className='form-control-input'
          type={showPassword ? 'text' : 'password'}
          style={borderStyle}
          {...rest}
        />
        <span
          id='btn-hide-show-password'
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? (
            <ShowPassword className='img-password-1' />
          ) : (
            <HidePassword className='img-password-2' />
          )}
        </span>
      </div>
      <p style={{ ...hasErrorStyle }} role='alert' data-testid='error-message'>
        {hasError ? messageError : ''}
      </p>
    </FormGroup>
  );
}

InputPassword.displayName = 'InputPassword';

export default InputPassword;
